module.exports = __webpack_public_path__ + "3f9f8f6adf5e55ac456ba024f50ca648.png";